import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { environment } from '@env/environment';

export const debugInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) =>
{
    if (!environment.debug)
    {
        return next(req.clone());
    }

    let params = req.params;

    if (!params.has('XDEBUG_SESSION_START'))
    {
        params = params.append('XDEBUG_SESSION_START', 'PHPSTORM');
    }

    return next(req.clone({
        params,
    }));
}
